import { useInfiniteQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { api } from '@/modules/common/api/index.ts';
import { REGISTER_ID_SEARCH_PARAM_KEY } from '@/modules/common/constants/search-params.ts';
import {
  GetIssuerCertificateListResponse,
  GetListByIssuerV1SrCertificatesIssuerGetParams,
} from 'api';

export const ISSUER_CERTIFICATES_LIST_QUERY_KEY = 'vestra-sr/issuer-certificates-list';

export const useIssuerGetCertificatesQuery = (
  payload: GetListByIssuerV1SrCertificatesIssuerGetParams,
) => {
  const { page, ...data } = payload;
  const [params] = useSearchParams();

  return useInfiniteQuery<GetIssuerCertificateListResponse>({
    queryKey: [
      ISSUER_CERTIFICATES_LIST_QUERY_KEY,
      JSON.stringify(data),
      params.get(REGISTER_ID_SEARCH_PARAM_KEY),
    ],
    staleTime: 1000 * 60 * 60, // 1 hours
    queryFn: async ({ pageParam = 0 }) => {
      const response = await api.v1.getListByIssuerV1SrCertificatesIssuerGet({
        ...data,
        page: pageParam || page,
      });
      return response.data;
    },
    refetchInterval: 1000 * 60 * 5, //5min
    keepPreviousData: true,
    retry: 2,
    getNextPageParam: ({ total, page, page_size }) => {
      const totalPage = Math.ceil(total / page_size);
      const hasMore = totalPage > page;
      if (hasMore) {
        return page + 1;
      }
    },
  });
};
